import { LikliHood } from 'src/enums';

/**
 * Custom screening sorting to make it order by likelihood
 *
 * @param screeningA - The first screening object.
 * @param screeningB - The second screening object.
 * @returns The result of the comparison between the two screening objects.
 */
export const sortScreeningResult = (screeningA: any, screeningB: any) => {
  const order: any = {};
  order[LikliHood.ExactMatch] = 1;
  order[LikliHood.VeryHigh] = 2;
  order[LikliHood.High] = 3;
  order[LikliHood.Medium] = 4;
  order[LikliHood.Low] = 5;
  order[LikliHood.VeryLow] = 6;
  order[''] = 7;

  const matchA = screeningA.match || ''; // If match field is null or undefined, treat it as an empty string
  const matchB = screeningB.match || ''; // If match field is null or undefined, treat it as an empty string

  return order[matchA] - order[matchB];
};
